import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useSubscription } from '../contexts/SubscriptionContext';

const { FiZap, FiArrowRight } = FiIcons;

function TrialBanner() {
  const navigate = useNavigate();
  const { isTrialActive, getDaysLeftInTrial, getHoursLeftInTrial } = useSubscription();
  const [daysLeft, setDaysLeft] = useState(0);
  const [hoursLeft, setHoursLeft] = useState(0);

  useEffect(() => {
    const updateCountdown = () => { setDaysLeft(getDaysLeftInTrial()); setHoursLeft(getHoursLeftInTrial()); };
    updateCountdown();
    const interval = setInterval(updateCountdown, 60000);
    return () => clearInterval(interval);
  }, [getDaysLeftInTrial, getHoursLeftInTrial]);

  if (!isTrialActive()) return null;

  const showHours = daysLeft < 2;
  const displayText = showHours
    ? `${hoursLeft} ${hoursLeft === 1 ? 'hour' : 'hours'} left`
    : `${daysLeft} ${daysLeft === 1 ? 'day' : 'days'} left`;

  return (
    <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} className="bg-gradient-to-r from-blue-600 to-purple-600 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 sm:py-3">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-3">
          <div className="flex items-center space-x-2 sm:space-x-3">
            <SafeIcon icon={FiZap} className="w-4 h-4 sm:w-5 sm:h-5 text-yellow-300 flex-shrink-0" />
            <div className="text-xs sm:text-sm sm:text-base">
              <span className="font-semibold">Free Trial Active:</span>
              <span className="ml-1 sm:ml-2">{displayText}</span>
            </div>
          </div>
          <button
            onClick={() => navigate('/settings?tab=subscription')}
            className="bg-white text-blue-600 px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg hover:bg-gray-100 transition-colors text-xs sm:text-sm font-semibold flex items-center space-x-1 sm:space-x-2 flex-shrink-0"
          >
            <span>Upgrade to Pro</span>
            <SafeIcon icon={FiArrowRight} className="w-3 h-3 sm:w-4 sm:h-4" />
          </button>
        </div>
      </div>
    </motion.div>
  );
}

export default TrialBanner;